// // PrintPreviewModal.js
// //
// // Shows a preview of a KOT or Bill, with a Print button.
// // "Print" currently opens the browser print dialog scoped to just this
// // content (via a hidden iframe, so the rest of the POS screen never bleeds
// // into the printout). When a real printer/service is wired up later, only
// // `printNow()` needs to change — the preview markup and call sites stay the same.

// import React from 'react';
// import { Dialog } from 'primereact/dialog';
// import { Button } from 'primereact/button';

// const fmtMoney = (n) => (Number(n) || 0).toFixed(2);
// const fmtTime = (d) => new Date(d).toLocaleString(undefined, {
//     day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
// });

// // ── Renders the printable content as a string, so the exact same markup
// //    is used both on-screen (preview) and inside the print iframe. ──────────
// function renderKotHtml(data) {
//     const groupsHtml = data.kitchenGroups.map(g => `
//         <div class="pp-kitchen-block">
//             <div class="pp-kitchen-name">${g.kitchenName}</div>
//             <table class="pp-table">
//                 <thead><tr><th>Item</th><th>Qty</th></tr></thead>
//                 <tbody>
//                     ${g.items.map(i => `
//                         <tr>
//                             <td>${i.name}${i.instruction ? `<div class="pp-note">${i.instruction}</div>` : ''}</td>
//                             <td>${i.qty}</td>
//                         </tr>
//                     `).join('')}
//                 </tbody>
//             </table>
//         </div>
//     `).join('');

//     return `
//         <div class="pp-header">
//             <div class="pp-title">KOT</div>
//             <div>${data.kotNumber}</div>
//             <div>${fmtTime(data.printedAt)}</div>
//         </div>
//         <div class="pp-meta">
//             ${data.tableNumber ? `<div>Table: <b>${data.tableNumber}</b></div>` : ''}
//             <div>Order: <b>${data.orderNumber}</b></div>
//             ${data.waiter ? `<div>Waiter: ${data.waiter}</div>` : ''}
//         </div>
//         ${groupsHtml || '<div class="pp-empty">No items to send.</div>'}
//     `;
// }

// function renderBillHtml(data) {
//     const rowsHtml = data.lineItems.map(i => `
//         <tr>
//             <td>${i.name}</td>
//             <td>${i.qty}</td>
//             <td>${fmtMoney(i.rate)}</td>
//             <td>${fmtMoney(i.amount)}</td>
//         </tr>
//     `).join('');

//     const s = data.summary;
//     const summaryRow = (label, value, skipIfZero = true) =>
//         (skipIfZero && !value) ? '' : `<div class="pp-summary-row"><span>${label}</span><span>${fmtMoney(value)}</span></div>`;

//     return `
//         <div class="pp-header">
//             <div class="pp-title">BILL</div>
//             <div>${data.billNumber}</div>
//             <div>${fmtTime(data.printedAt)}</div>
//         </div>
//         <div class="pp-meta">
//             ${data.tableNumber ? `<div>Table: <b>${data.tableNumber}</b></div>` : ''}
//             ${data.customerName ? `<div>Customer: ${data.customerName}</div>` : ''}
//             ${data.customerMobile ? `<div>Mobile: ${data.customerMobile}</div>` : ''}
//         </div>
//         <table class="pp-table">
//             <thead><tr><th>Item</th><th>Qty</th><th>Rate</th><th>Amt</th></tr></thead>
//             <tbody>${rowsHtml || '<tr><td colspan="4" class="pp-empty">No billable items.</td></tr>'}</tbody>
//         </table>
//         <div class="pp-summary">
//             ${summaryRow('Gross', s.gross, false)}
//             ${summaryRow('Item Discount', s.itemDiscount)}
//             ${summaryRow('Bill Discount', s.billDiscount)}
//             ${summaryRow('Tax', s.tax)}
//             ${summaryRow('Service Charge', s.serviceCharge)}
//             ${summaryRow('Packing Charge', s.packingCharge)}
//             ${summaryRow('Delivery Charge', s.deliveryCharge)}
//             ${summaryRow('Round Off', s.roundOff)}
//             <div class="pp-summary-row pp-grand-total"><span>Grand Total</span><span>${fmtMoney(s.grandTotal)}</span></div>
//         </div>
//         ${data.payment ? `
//             <div class="pp-meta pp-payment">
//                 <div>Payment: <b>${data.payment.status}</b></div>
//                 ${data.payment.changeReturn ? `<div>Change Returned: ${fmtMoney(data.payment.changeReturn)}</div>` : ''}
//             </div>
//         ` : ''}
//     `;
// }

// const PRINT_STYLES = `
//     body { font-family: 'Courier New', monospace; width: 280px; margin: 0 auto; color: #000; }
//     .pp-header { text-align: center; border-bottom: 1px dashed #000; padding-bottom: 6px; margin-bottom: 6px; }
//     .pp-title { font-size: 18px; font-weight: bold; }
//     .pp-meta { font-size: 12px; margin-bottom: 8px; }
//     .pp-meta div { margin-bottom: 2px; }
//     .pp-kitchen-block { margin-bottom: 10px; }
//     .pp-kitchen-name { font-weight: bold; font-size: 13px; text-transform: uppercase; margin-bottom: 4px; }
//     .pp-table { width: 100%; border-collapse: collapse; font-size: 12px; }
//     .pp-table th, .pp-table td { text-align: left; padding: 2px 4px; }
//     .pp-table th { border-bottom: 1px solid #000; }
//     .pp-note { font-size: 10px; font-style: italic; color: #333; }
//     .pp-summary { margin-top: 8px; border-top: 1px dashed #000; padding-top: 6px; font-size: 12px; }
//     .pp-summary-row { display: flex; justify-content: space-between; padding: 1px 0; }
//     .pp-grand-total { font-weight: bold; font-size: 14px; border-top: 1px solid #000; margin-top: 4px; padding-top: 4px; }
//     .pp-payment { border-top: 1px dashed #000; margin-top: 8px; padding-top: 6px; }
//     .pp-empty { text-align: center; color: #666; padding: 8px 0; }
// `;

// // ── Iframe-based print: isolates the printout from the rest of the app so
// //    the browser print dialog only shows this content, nothing else on screen. ──
// function printNow(html) {
//     const iframe = document.createElement('iframe');
//     iframe.style.position = 'fixed';
//     iframe.style.right = '0';
//     iframe.style.bottom = '0';
//     iframe.style.width = '0';
//     iframe.style.height = '0';
//     iframe.style.border = '0';
//     document.body.appendChild(iframe);

//     const doc = iframe.contentWindow.document;
//     doc.open();
//     doc.write(`<html><head><title>Print</title><style>${PRINT_STYLES}</style></head><body>${html}</body></html>`);
//     doc.close();

//     iframe.contentWindow.focus();
//     // Give the iframe a tick to lay out before invoking print
//     setTimeout(() => {
//         iframe.contentWindow.print();
//         setTimeout(() => document.body.removeChild(iframe), 500);
//     }, 150);
// }

// export default function PrintPreviewModal({ visible, type, data, onHide }) {
//     if (!data) return null;

//     const html = type === 'kot' ? renderKotHtml(data) : renderBillHtml(data);
//     const headerLabel = type === 'kot' ? 'KOT Preview' : 'Bill Preview';

//     return (
//         <Dialog
//             header={headerLabel}
//             visible={visible}
//             onHide={onHide}
//             className="pos-print-preview-dialog"
//             style={{ width: '340px' }}
//             dismissableMask
//             footer={
//                 <div className="p-d-flex p-jc-end p-gap-2">
//                     <Button label="Close" className="p-button-outlined" onClick={onHide} />
//                     <Button label="Print" icon="pi pi-print" className="p-button-primary" onClick={() => printNow(html)} />
//                 </div>
//             }
//         >
//             <style>{PRINT_STYLES}</style>
//             <div className="pos-print-preview-content" dangerouslySetInnerHTML={{ __html: html }} />
//         </Dialog>
//     );
// }



// PrintPreviewModal.js
//
// Shows a preview of a KOT or Bill, with a Print button.
// "Print" currently opens the browser print dialog scoped to just this
// content (via a hidden iframe, so the rest of the POS screen never bleeds
// into the printout). When a real printer/service is wired up later, only
// `printNow()` needs to change — the preview markup and call sites stay the same.
//
// Styling for both the on-screen preview and the print iframe comes from
// the global .pp-print-root block in modal.scss — there is no separate
// style definition in this file. The iframe clones the app's own
// <link>/<style> tags so it renders with the exact same compiled CSS.

import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const fmtMoney = (n) => (Number(n) || 0).toFixed(2);
const fmtTime = (d) => new Date(d).toLocaleString(undefined, {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

// ── Renders the printable content as a string, so the exact same markup
//    is used both on-screen (preview) and inside the print iframe. ──────────
function renderKotHtml(data) {
    const groupsHtml = data.kitchenGroups.map(g => `
        <div class="pp-kitchen-block">
            <div class="pp-kitchen-name">${g.kitchenName}</div>
            <table class="pp-table">
                <thead><tr><th>Item</th><th>Qty</th></tr></thead>
                <tbody>
                    ${g.items.map(i => `
                        <tr>
                            <td>${i.name}${i.instruction ? `<div class="pp-note">${i.instruction}</div>` : ''}</td>
                            <td>${i.qty}</td>
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        </div>
    `).join('');

    return `
        <div class="pp-header">
            <div class="pp-title">KOT</div>
            <div>${data.kotNumber}</div>
            <div>${fmtTime(data.printedAt)}</div>
        </div>
        <div class="pp-meta">
            ${data.tableNumber ? `<div>Table: <b>${data.tableNumber}</b></div>` : ''}
            <div>Order: <b>${data.orderNumber}</b></div>
            ${data.waiter ? `<div>Waiter: ${data.waiter}</div>` : ''}
        </div>
        ${groupsHtml || '<div class="pp-empty">No items to send.</div>'}
    `;
}

function renderBillHtml(data) {
    const rowsHtml = data.lineItems.map(i => `
        <tr>
            <td>${i.name}</td>
            <td>${i.qty}</td>
            <td>${fmtMoney(i.rate)}</td>
            <td>${fmtMoney(i.amount)}</td>
        </tr>
    `).join('');

    const s = data.summary;
    const summaryRow = (label, value, skipIfZero = true) =>
        (skipIfZero && !value) ? '' : `<div class="pp-summary-row"><span>${label}</span><span>${fmtMoney(value)}</span></div>`;

    return `
        <div class="pp-header">
            <div class="pp-title">BILL</div>
            <div>${data.billNumber}</div>
            <div>${fmtTime(data.printedAt)}</div>
        </div>
        <div class="pp-meta">
            ${data.tableNumber ? `<div>Table: <b>${data.tableNumber}</b></div>` : ''}
            ${data.customerName ? `<div>Customer: ${data.customerName}</div>` : ''}
            ${data.customerMobile ? `<div>Mobile: ${data.customerMobile}</div>` : ''}
        </div>
        <table class="pp-table">
            <thead><tr><th>Item</th><th>Qty</th><th>Rate</th><th>Amt</th></tr></thead>
            <tbody>${rowsHtml || '<tr><td colspan="4" class="pp-empty">No billable items.</td></tr>'}</tbody>
        </table>
        <div class="pp-summary">
            ${summaryRow('Gross', s.gross, false)}
            ${summaryRow('Item Discount', s.itemDiscount)}
            ${summaryRow('Bill Discount', s.billDiscount)}
            ${summaryRow('Tax', s.tax)}
            ${summaryRow('Service Charge', s.serviceCharge)}
            ${summaryRow('Packing Charge', s.packingCharge)}
            ${summaryRow('Delivery Charge', s.deliveryCharge)}
            ${summaryRow('Round Off', s.roundOff)}
            <div class="pp-summary-row pp-grand-total"><span>Grand Total</span><span>${fmtMoney(s.grandTotal)}</span></div>
            <div class="pp-summary-row pp-bill-status"><span>Bill Status</span><span>${data.billStatus}</span></div>
        </div>
        ${data.payment ? `
            <div class="pp-meta pp-payment">
                ${data.payment.entries.map(e => `
                    <div class="pp-summary-row">
                        <span>${e.method}${e.transactionNo ? ` (${e.transactionNo})` : ''}</span>
                        <span>${fmtMoney(e.amount)}</span>
                    </div>
                `).join('')}
                <div>Amount Paid: <b>${fmtMoney(data.payment.totalPaid)}</b></div>
                ${data.payment.balance ? `<div>Balance Due: <b>${fmtMoney(data.payment.balance)}</b></div>` : ''}
                ${data.payment.changeReturn ? `<div>Change Returned: ${fmtMoney(data.payment.changeReturn)}</div>` : ''}
            </div>
        ` : ''}
    `;
}

// ── Iframe-based print: isolates the printout from the rest of the app so
//    the browser print dialog only shows this content, nothing else on screen.
//    Clones the app's own stylesheet <link>/<style> tags into the iframe so
//    it picks up the same .pp-print-root rules defined in modal.scss. ────────
function printNow(html) {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    const headTags = Array.from(document.querySelectorAll('link[rel="stylesheet"], style'))
        .map((el) => el.outerHTML)
        .join('');

    doc.open();
    doc.write(`<html><head><title>Print</title>${headTags}</head><body class="pp-print-root">${html}</body></html>`);
    doc.close();

    iframe.contentWindow.focus();
    // Give the iframe a tick to lay out (and let stylesheets load) before invoking print
    setTimeout(() => {
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 500);
    }, 150);
}

// onPrint, when supplied, replaces the browser print dialog - the caller sends
// the ticket to the print service instead. Without it the Print button keeps
// its original behaviour, so the KOT path is unchanged.
export default function PrintPreviewModal({ visible, type, data, onHide, onPrint }) {
    if (!data) return null;

    const html = type === 'kot' ? renderKotHtml(data) : renderBillHtml(data);
    const headerLabel = type === 'kot' ? 'KOT Preview' : 'Bill Preview';

    return (
        <Dialog
            header={headerLabel}
            visible={visible}
            onHide={onHide}
            className="pos-print-preview-dialog"
            dismissableMask
            footer={
                <div className="pos-modal-actions">
                    <Button label="Close" className="p-button-outlined" onClick={onHide} />
                    <Button
                        label="Print"
                        icon="pi pi-print"
                        className="p-button-primary"
                        onClick={onPrint ? onPrint : () => printNow(html)}
                    />
                </div>
            }
        >
            <div className="pp-print-root pos-print-preview-content" dangerouslySetInnerHTML={{ __html: html }} />
        </Dialog>
    );
}